import {
    GLOBAL_RESET_PDF_PREVIEW_DATA,
    GLOBAL_STORE_PDF_PREVIEW_READY,
    POINT_RESET_PDF_PREVIEW_DATA,
    POINT_STORE_PDF_PREVIEW_READY,
    STORE_ALL_ROLLOVER_REQUEST_TRANSACTION,
    STORE_ALL_TICKET_OUT,
    STORE_ALL_TRANSACTION, STORE_REPORT_PHOTOS,
    STORE_UPDATED_TICKET_OUT,
    STORE_UPDATED_TRANSACTION, TRANSACTION_RESET_PDF_PREVIEW_DATA, TRANSACTION_STORE_PDF_PREVIEW_READY,
} from '../../constants/ticketOut';
import {
    MASTER_READING_RESET_PDF_PREVIEW_DATA,
    MASTER_READING_STORE_PDF_PREVIEW_READY,
    MATCH_POINT_RESET_PDF_PREVIEW_DATA,
    MATCH_POINT_STORE_PDF_PREVIEW_READY
} from "../../constants/settings";

const initialState = {
    ticketOut: [],
    transactions: [],
    rollOverRequests: [],
    storePDFPreviewReady: new Uint8Array(0),
    storePointPDFPreviewReady: new Uint8Array(0),
    storeMatchPointPDFPreviewReady: new Uint8Array(0),
    storeMasterReadingPDFPreviewReady: new Uint8Array(0),
    storeGlobalPDFPreviewReady: new Uint8Array(0),
    reportPhotos: []
};

export const updateList = (newItem, oldList, key) => {
    let newList = [...oldList]; // Create a copy of the old list

    // Check if the newItem already exists in the oldList
    let exists = oldList.findIndex(item => item[key] === newItem[key]);

    if (exists === -1) {
        // If not found, add the newItem to the end of the list
        newList.push(newItem);
    } else {
        // If found, replace the existing item with newItem
        newList[exists] = newItem;
    }

    return newList;
}

export const updateTransaction = (newItem, oldItem, key) => {
    let listKey = newItem.type === "bank" ? "bankList" : "expenseList"; // Determine the correct list

    let newList = [...oldItem[listKey]]; // Create a copy of the old list

    // Check if the newItem already exists in the old list based on the provided key
    let exists = newList.findIndex(item => item[key] === newItem[key]);

    if (exists === -1) {
        // If not found, add the newItem to the end of the list
        newList.push(newItem);
    } else {
        // If found, replace the existing item with newItem
        newList[exists] = newItem;
    }

    // Return the updated object with the modified list
    return {
        ...oldItem,
        [listKey]: newList
    };
}


export default (state = initialState, action) => {
    switch (action.type) {
        case STORE_UPDATED_TICKET_OUT:
            return {
                ...state,
                ticketOut: updateList(action.data, state.ticketOut, 'ticketId')
            }
        case STORE_ALL_TICKET_OUT:
            return {
                ...state,
                ticketOut: action.data
            }
            //Transaction:
        case STORE_UPDATED_TRANSACTION:
            return {
                ...state,
                transactions: updateTransaction(action.data, state.transactions, 'transactionId')
            }
        case STORE_ALL_TRANSACTION:
            return {
                ...state,
                transactions: action.data
            }
        case TRANSACTION_STORE_PDF_PREVIEW_READY:
            return {
                ...state,
                storePDFPreviewReady: action.storePDFPreviewReady
            }
        case TRANSACTION_RESET_PDF_PREVIEW_DATA:
            return {
                ...state,
                storePDFPreviewReady: new Uint8Array(0),
            }
        case STORE_ALL_ROLLOVER_REQUEST_TRANSACTION:
            return {
                ...state,
                rollOverRequests: action.data
            }
            //point pdf
        case POINT_STORE_PDF_PREVIEW_READY:
            return {
                ...state,
                storePointPDFPreviewReady: action.storePointPDFPreviewReady
            }
        case POINT_RESET_PDF_PREVIEW_DATA:
            return {
                ...state,
                storePointPDFPreviewReady: new Uint8Array(0),
            }
        case MATCH_POINT_STORE_PDF_PREVIEW_READY:
            return {
                ...state,
                storeMatchPointPDFPreviewReady: action.storeMatchPointPDFPreviewReady
            }
        case  MATCH_POINT_RESET_PDF_PREVIEW_DATA:
            return {
                ...state,
                storeMatchPointPDFPreviewReady: new Uint8Array(0),
            }
            //mast reading
        case MASTER_READING_STORE_PDF_PREVIEW_READY:
            return {
                ...state,
                storeMasterReadingPDFPreviewReady: action.storeMasterReadingPDFPreviewReady
            }
        case  MASTER_READING_RESET_PDF_PREVIEW_DATA:
            return {
                ...state,
                storeMasterReadingPDFPreviewReady: new Uint8Array(0),
            }
        case GLOBAL_STORE_PDF_PREVIEW_READY:
            return {
                ...state,
                storeGlobalPDFPreviewReady: action.storePDFPreviewReady
            }
        case STORE_REPORT_PHOTOS:
            return {
                ...state,
                reportPhotos: action.reportPhotos
            }
        case  GLOBAL_RESET_PDF_PREVIEW_DATA:
            return {
                ...state,
                storeGlobalPDFPreviewReady: new Uint8Array(0),
            }
        default:
            return state
    }
}